import React from 'react'
import styles from 'components/Nav/nav.module.scss'
import { Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import Nav from 'components/Nav'
import PropTypes from 'prop-types'

const TopLevel = ({ routeKey, label_key, routes, level }) => {
  const { t } = useTranslation()

  return (
    <div className={styles['nav__item_level_1']} key={'level-1-' + routeKey}>
      <div key={'navlink-' + routeKey}>
        <Typography
          component={'div'}
          variant={'Body-10'}
          color={'Label-Tertiary'}
          className={styles['group-header']}
        >
          {t(label_key)}
        </Typography>
        {routes?.length > 0 && <Nav items={routes} level={level + 1} />}
      </div>
    </div>
  )
}

export default TopLevel

TopLevel.propTypes = {
  routeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  label_key: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object),
  level: PropTypes.number.isRequired,
}
